import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["bus-location-wrapper", {
      'main-card': $props.showInMainCard,
      'enter-this-stop': $props.busStopEventCode === $setup.BusStopEventCode.Enter,
      'leave-this-stop': $props.busStopEventCode === $setup.BusStopEventCode.Leave,
      'multiple-buses': $setup.isMultipleBuses,
    }])
  }, [
    ($setup.bubbleText)
      ? (_openBlock(), _createBlock($setup["BusLocationIndicatorBubble"], {
          key: 0,
          displayText: $setup.bubbleText,
          underline: $setup.isMultipleBuses,
          isFullSeat: $setup.isNonInsideShuttleFullSeat,
          onOnClick: $setup.emitOnClickBubble
        }, null, 8 /* PROPS */, ["displayText", "underline", "isFullSeat"]))
      : _createCommentVNode("v-if", true),
    _createVNode($setup["MultiBusIndicator"], {
      busLocations: $setup.sortedBusLocations,
      selectedBus: $props.selectedBus,
      allBusesMap: $props.allBusesMap,
      isFullSeat: $setup.isNonInsideShuttleFullSeat,
      onOnClick: $setup.emitOnClickBusIcon
    }, null, 8 /* PROPS */, ["busLocations", "selectedBus", "allBusesMap", "isFullSeat"])
  ], 2 /* CLASS */))
}